import SwitcherLevel from './SwitcherLevel';

export default SwitcherLevel;
